import Constants from '@/Constants';
import { BadgeTranslation } from '@/models/BadgeTranslation';
import { PersonBadge } from '@/models/PersonBadge';
import { momentWithTimeZone } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface Props {
    personBadge: PersonBadge;
}

type AchievementType = 'Badge' | 'Token';

const AchievementCard: React.FC<Props> = ({ personBadge }: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));

    const [currentBadgeTranslation, setCurrentBadgeTranslation] = useState<BadgeTranslation>();

    const { badge, campaign } = personBadge;

    const { badgeTranslations } = badge;

    const achievementType: AchievementType = !!badge.isToken ? 'Token' : 'Badge';

    const isGranted: boolean = personBadge.progress === 100;

    const getImage = (): string => {
        const path = Constants.imageFolders.STATIC_ASSETS_BADGES.replace('%k', badge.key);
        const imageName = personBadge.progress === 100 ? Constants.badgeImages.THUMB : Constants.badgeImages.THUMB_DISABLED;

        return `${path}${imageName}`;
    };

    useEffect(() => {
        if (badgeTranslations) {
            setCurrentBadgeTranslation(badgeTranslations.find((bt: BadgeTranslation) => bt.locale === strings._LANGUAGE));
        }
    }, [strings._LANGUAGE, badgeTranslations]);

    return (
        <>
            {badge && currentBadgeTranslation && (
                <div className="achievement-card">
                    <div className="achievement-card__info">
                        <img alt="" className="achievement-card__info-image" src={getImage()} />
                        <div className="achievement-card__info-content">
                            <div className="achievement-card__info-content-main">
                                <span className="achievement-type">{achievementType}</span>
                                <span className="achievement-title">{currentBadgeTranslation.name}</span>
                                <p dangerouslySetInnerHTML={{ __html: currentBadgeTranslation.description }} />

                                {isGranted && achievementType === 'Token' && !!personBadge.token && (
                                    <div className="achievement-card__info-auth-certificate">
                                        <a
                                            href={`${Constants.BADGE_AUTH_CERTIFICATE_LINK}${personBadge.token}`}
                                            rel="noopener noreferrer"
                                            target="_blank"
                                        >
                                            <span>{strings.ACHIEVEMENTS.ACCESS_CERTIFICATE_AUTHENTICITY}</span>
                                            <i className="material-icons">{Constants.icons.REPLY_BACK}</i>
                                        </a>
                                    </div>
                                )}

                                {!isGranted && (
                                    <>
                                        <span className="achievement-progress">
                                            {strings.ACHIEVEMENTS.YOUR_CURRENT_PROGRESS_IS}{' '}
                                            <span
                                                className="achievement-progress-value"
                                                style={{ fontWeight: personBadge.progress > 0 ? 'bolder' : 'normal' }}
                                            >
                                                {personBadge.progress}%
                                            </span>
                                        </span>
                                        <div className="achievement-card__info-content-main-progress-bar">
                                            <div className="current-progress" style={{ width: `${personBadge.progress}%` }} />
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="achievement-card__info-content-footer">
                                {campaign.endDate && !isGranted && (
                                    <span>{`${strings.ACHIEVEMENTS.AVAILABLE_UNTIL} ${momentWithTimeZone(campaign.endDate, strings._LANGUAGE)}`}</span>
                                )}
                                {isGranted && <span>{`${strings.ACHIEVEMENTS.GRANTED_IN} ${momentWithTimeZone(personBadge.updatedOn, strings._LANGUAGE)}`}</span>}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AchievementCard;
